import { useQueryClient, useMutation } from 'react-query'
import { api } from '../../utils/gql-client'
import {
  CreateReportTemplateMutationVariables as Variables,
  CreateReportTemplateMutation as Response
} from '../../API'
import { createReportTemplate as query } from '../../graphql/mutations'
import { REPORT_TEMPLATE_LIST_KEY } from './useFetchTemplateList'

function useCreateTemplate() {
  const queryClient = useQueryClient()

  return useMutation((variables: Variables) => {
    return api.request<Response>({ query, variables })
  }, {
    onSuccess: () => {
      return queryClient.invalidateQueries(REPORT_TEMPLATE_LIST_KEY)
    }
  })
}

export { useCreateTemplate }
